import { computed } from "vue";
import { useUserStore } from "@/store/user";
import { resolveUserSegmentFromStore } from "@/assets/pay/activityPricing";
import { getActivity618DebugSegment } from "@/utils/activity618Debug";
import type { UserSegment } from "../components/VipPackageActivity/types";

/**
 * 618 活动用户分层
 *
 * 判定优先级：ultra 在籍 > 付费在籍 > 过期 > 未付费
 * 分层结果驱动：活动 UI 展示/隐藏、定价表命中、弹窗文案选择
 */
export function use618UserSegment() {
  const userStore = useUserStore();

  const segment = computed<UserSegment>(() => {
    const debugSegment = getActivity618DebugSegment();
    if (debugSegment) return debugSegment;
    return resolveUserSegmentFromStore(userStore);
  });

  /** VVIP 在籍用户不参与 618，保持日常页面与弹窗 */
  const is618Enabled = computed(() => segment.value !== "activeUltra");

  /** 当前用户的最高套餐键（用于定价查询） */
  const currentTier = computed(() => userStore.highestPackage);

  return {
    segment,
    is618Enabled,
    currentTier
  };
}
